// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__QocAg","inner":"Form_inner__sePjw","range":"Form_range__6hVmG","name":"Form_name__3UwFG","actions":"Form_actions__1rAsY"};